<script setup lang="ts">
defineProps<{ isOpen: boolean; modalNum: number }>();
defineEmits<{ close: [] }>();
</script>

<template>
  <div>
    <div
      v-if="isOpen"
      class="be-modalbg"
      :class="{ 'is-modalopen': isOpen }"
      @click="$emit('close')"
    ></div>
    <div v-if="isOpen" class="be-modal" :class="{ 'is-modalopen': isOpen }">
      <div class="be-modal__closebtn" @click="$emit('close')">
        <span>×<span> Close</span></span>
      </div>
      <div class="be-modal-scroll" v-show="modalNum === 1">
        <h2>情報セキュリティ方針</h2>
        <p>詳細は公式ポリシーページをご確認ください。</p>
        <p>
          <a
            href="https://bot-express.notion.site/fd5ac5126d4f4b79ae0ad75b8dd923d3"
            target="_blank"
            rel="noopener"
            >情報セキュリティ方針（外部ページ）</a
          >
        </p>
      </div>
      <div class="be-modal-scroll" v-show="modalNum === 2">
        <h2>個人情報保護基本方針</h2>
        <p>詳細は公式ポリシーページをご確認ください。</p>
        <p>
          <a
            href="https://bot-express.notion.site/a37097a3f3934ac29dadbf6e263987fc"
            target="_blank"
            rel="noopener"
            >個人情報保護基本方針（外部ページ）</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
